// Vendor Libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';

// Components
import Checkbox from '../core/checkbox';
import DateRange from '../core/date-range';
import Icon from '../core/icon';
import Input from '../core/input';
import LanguageSelect from '../app/language-select';
import Loading from '../core/loading';
import NetworkSelect from '../app/network-select';
import ProviderSelect from '../app/provider-select';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import Select from '../core/select';
import ServiceSelect from '../app/service-select';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchForm from '../app/services-search-form';
import ServicesSearchPanelAction from '../app/services-search-panel-action';
import TooltipTrigger from '../core/tooltip-trigger';

// Containers
import withSearch from '../../containers/with-search';
import GenreSelect from '../app/genre-select';

const servicesDataKey = 'mediaItemsMapped';

class MediaItemsMapped extends Component {
  getColumnConfig() {
    return [
      {
        dataKey: 'locked',
        formatter: 'lockedByIcon',
        maxWidth: '20px',
        tooltip: 'Locked By',
        width: '5%',
      },
      {
        className: 'table-with-sort--word-break',
        dataKey: 'title',
        formatter: 'lockedLink',
        link: '/media-items',
        linkKey: 'guid',
        sortKey: 'title.sortable',
        title: 'Title',
        type: 'link',
        width: '20%',
      },
      {
        dataKey: 'service.serviceName',
        title: 'Service',
        width: '10%',
      },
      {
        dataKey: 'externalNetwork.name',
        title: 'Network',
        width: '14%',
      },
      {
        className: 'table-with-sort--word-break',
        dataKey: 'showName',
        sortKey: 'showName.sortable',
        title: 'Show Name',
        width: '18%',
      },
      {
        dataKey: 'offerings.0.startDate',
        sortKey: 'offerings.startDate',
        title: 'Start Date',
        tooltip: 'Start Date',
        type: 'date',
        width: '10%',
      },
      {
        dataKey: 'lastUpdated',
        title: 'Last Update',
        tooltip: 'Last Updated',
        type: 'date',
        width: '10%',
      },
      {
        addClassToCell: true,
        dataKey: 'state',
        renderRowCallback: this.renderStateAndMapped,
        title: 'State',
        width: '13%',
      },
    ];
  }

  getPaginationProps() {
    const { query, totalPages } = this.props;

    return {
      maxResults: 10000,
      maxPages: 9,
      query,
      totalPages,
    };
  }

  getTablewithsortProps() {
    return {
      columnConfig: this.getColumnConfig(),
      formName: servicesDataKey,
      noRecordsError: 'No mapped media items found.',
      noReset: true,
      rowDetails: {
        whitelistKeys: [
          'guid',
          'description',
          'releaseYear',
          'originalAirDate',
          'seasonNumber',
          'episodeNumber',
          'duration',
          'rating',
          'lang',
          'genres',
          'createdBy',
          'lastModifiedBy',
        ],
      },
      servicesDataKey,
      ...this.props,
    };
  }

  getSearchExportPanelProps = (searchData) => {
    const { totalElements, query } = this.props;

    return {
      totalElements,
      query,
      searchData,
    };
  };

  renderForm = () => (
        <ServicesSearchForm advancedSearch={true} formName={servicesDataKey} servicesDataKey={servicesDataKey}>
            <Input label="Title/Show Name" name="title||showName" />
            <Checkbox label="Exact Match" name="exactSearch" value="true" />
            <LanguageSelect defaultOption="Filter by Language" label="Language" name="lang" />
            <Input label="Asset Echostar3 ID" name="amsEpisode.echostarEventString" />
            <Input label="Franchise Echostar3 ID" name="amsFranchise.echostarEventString" />
            <ServiceSelect label="Services" name="service.serviceName" />
            <Select label="State" name="state">
                <option value="">Filter by State</option>
                <option value="enrichment">ENRICHMENT</option>
                <option value="encoding">ENCODING</option>
                <option value="pre_production">PRE PRODUCTION</option>
                <option value="production">PRODUCTION</option>
            </Select>
            <ProviderSelect label="Provider" name="provider.partnerId" />
            <GenreSelect className="display-inline-block" label="AMS Franchise Genres" name="amsFranchise.genres" />
            <GenreSelect className="display-inline-block" label="AMS Episode Genres" name="amsEpisode.genres" />
            <Input label="ID from Partner" name="idFromPartner" />
            <NetworkSelect label="Network" name="externalNetwork.name||externalNetwork.network.name" />
            <Input label="External Network" name="externalNetwork.name" />
            <Input label="GUID" name="guid||externalGuid" />
            <Input label="RUID" name="offerings.resourceId" />
            <Input label="Categories" name="categories.value" />
            <Select label="Clip" name="expression">
                <option value="">Filter by Clip</option>
                <option value="clip">Show clips only</option>
                <option value="!clip">Hide all clips</option>
            </Select>
            <Input label="EIDR" name="amsFranchise.eidrId||amsEpisode.eidrId" />
            <Input
                label="Mapped AMS Title"
                name="amsFranchise.title||amsFranchise.seriesTitle||amsEpisode.title||amsEpisode.seriesTitle"
            />
            <Select label="Missing Image" name="amsFranchise.images.category">
                <option value="">Filter by Missing Image</option>
                <option value="!Franchise">Missing Franchise images</option>
                <option value="!TitleArt">Missing Title Art images</option>
                <option value='=not_in=("Franchise","TitleArt")'>Missing Title Art and Franchise images</option>
            </Select>
            <Select label="Active" name="activeOnly">
                <option value="">Filter by Active</option>
                <option value="true">Active Only</option>
                <option value='=rsql=inactiveOnly=="true"'>Inactive Only</option>
            </Select>
            <Select label="Auto-Mapped Reason" name="autoMappedReason">
                <option value="">Filter by Auto-Mapped Reason</option>
                <option value="Echostar">Echostar ID</option>
                <option value="Echostar3">Echostar3 ID</option>
                <option value="TMS">TMS ID</option>
                <option value="EIDR">EIDR ID</option>
                <option value="Rovi">Rovi ID / AMS ID</option>
                <option value="REPLAY">Map & Remember Rule</option>
                <option value="joint">DISH Group Joint Mapping</option>
                <option value="notNull">All Auto-Mapped</option>
                <option value="isNull">None</option>
            </Select>
            <DateRange label="Last Updated" name="lastUpdated" showTime={true} />
            <DateRange label="Last Mapping Time" name="lastMappingTime" showTime={true} />
            <DateRange label="Date Published" name="publishDate" showTime={true} />
            <DateRange label="Offerings Start Date" name="offerings.startDate" />
            <DateRange label="Offerings End Date" name="offerings.endDate" />
            <Select label="Offerings Type" name="offerings.type">
                <option value="">Select a Type</option>
                <option value="SVOD">SVOD - Subscription</option>
                <option value="TVOD">TVOD - Rental</option>
                <option value="FVOD">FVOD - Free</option>
                <option value="FREE">FREE</option>
                <option value="EST">EST - Purchase</option>
            </Select>
        </ServicesSearchForm>
  );

  renderStateAndMapped = (dataRow) => {
    const { amsEpisode, amsFranchise, autoMappedReason, fullyFranchiseMapped, state } = dataRow;
    const isMapped = () => {
      const franchiseType = get(amsFranchise, 'echostarContentType');
      let mappedResult;

      if (!isEmpty(amsEpisode)) {
        mappedResult = true;
      } else if (!isEmpty(amsFranchise)) {
        mappedResult = franchiseType !== 'SRM' || fullyFranchiseMapped;
      }

      return mappedResult;
    };
    const tooltipRenderer = () => <div className="media-items-mapped--tooltip">{autoMappedReason}</div>;
    const getMappedIcon = () => (autoMappedReason ? (
                <TooltipTrigger tooltipRenderer={tooltipRenderer}>
                    <Icon fontType="fa" iconName="location-arrow" />
                </TooltipTrigger>
            ) : (
                <Icon fontType="fa" iconName="map-marker" title="mapped" />
            ));

    return (
            <div style={{ whiteSpace: 'nowrap' }}>
                {isMapped() ? getMappedIcon() : null}
                {state}
            </div>
    );
  };

  render() {
    const { fetching, searchData } = this.props;

    return (
            <div className="media-items-mapped">
                <Loading loading={fetching} />
                <ServicesExportPanelAction exportConfig="mediaItems" {...this.getSearchExportPanelProps(searchData)} />
                <ServicesSearchPanelAction contentRenderer={this.renderForm} />
                <SearchPagination {...this.getPaginationProps()} />
                <SearchTableWithSort {...this.getTablewithsortProps()} />
            </div>
    );
  }
}

MediaItemsMapped.propTypes = {
  fetching: PropTypes.bool,
  query: PropTypes.object,
  searchData: PropTypes.array,
  totalElements: PropTypes.number,
  totalPages: PropTypes.number,
};

export default withSearch(MediaItemsMapped, servicesDataKey);
